import React from "react"

type Props = {}

function NotFound({}: Props) {
  return <div>NotFound</div>
}

export default NotFound
